<template>
  <div id="nav-header">
    <div class="logo">
      <router-link to="/">
        <img :src="logo" all="Logo EW" />
      </router-link>
    </div>

    <div id="search" class="form-search full">
      <ul
        class="menu-mylists"
        v-if="
          $route.name == 'mylists' ||
          $route.name == 'experiences-lists' ||
          $route.name == 'tours-lists' ||
          $route.name == 'events-lists' ||
          $route.name == 'stories-lists'
        "
      >
        <router-link to="/lists/my-lists" tag="li">My Listings</router-link>
        <router-link to="/lists/experiences-lists" tag="li"
          >Experiences</router-link
        >
        <router-link to="/lists/tours-lists" tag="li">Tours</router-link>
        <router-link to="/lists/events-lists" tag="li">Events</router-link>
        <router-link to="/lists/stories-lists" tag="li">Stories</router-link>
        <li @click="logout">Logout</li>
      </ul>

      <ul
        class="menu-mylists"
        v-if="
          $route.name == 'contests' ||
          $route.name == 'join-contest' ||
          $route.name == 'contest-results'
        "
      >
        <router-link to="/contests" tag="li">Contests</router-link>
        <router-link to="/contests/join" tag="li">Join Contest</router-link>
        <router-link to="/contests/results" tag="li">Results</router-link>
        <li @click="logout">Logout</li>
      </ul>

      <ul
        class="menu-promotor"
        v-if="
          $route.name == 'promotions' ||
          $route.name == 'boost' ||
          $route.name == 'advertise' ||
          $route.name == 'message'
        "
      >
        <router-link to="/promoter" tag="li">My Promotions</router-link>
        <router-link to="/promoter/boost" tag="li">Boost</router-link>
        <router-link to="/promoter/advertise" tag="li">Advertise</router-link>
        <router-link to="/promoter/message" tag="li">Message</router-link>
        <!-- <li @click="logout">Logout</li> -->
      </ul>

      <ul
        class="menu-mylists"
        v-if="$route.name == 'rewarder' || $route.name == 'badges'"
      >
        <router-link to="/rewarder" tag="li">My Rewards</router-link>
        <router-link to="/rewarder/badges" tag="li">My Badges</router-link>
      </ul>

      <!-- <input type="text" class="input-search" placeholder="Search ENWOKE" />

      <div id="notifications" class="notifications">
        Notifications
        <div class="notifications-count" v-if="loginStatus">77</div>
      </div> -->
    </div>

    <Slide right noOverlay>
      <div id="search" class="form-search">
        <ul
          class="menu-mylists"
          v-if="
            $route.name == 'mylists' ||
            $route.name == 'experiences-lists' ||
            $route.name == 'tours-lists' ||
            $route.name == 'events-lists' ||
            $route.name == 'stories-lists'
          "
        >
          <router-link to="/lists/my-lists" tag="li">My Listings</router-link>
          <router-link to="/lists/experiences-lists" tag="li"
            >Experiences</router-link
          >
          <router-link to="/lists/tours-lists" tag="li">Tours</router-link>
          <router-link to="/lists/events-lists" tag="li">Events</router-link>
          <router-link to="/lists/stories-lists" tag="li">Stories</router-link>
          <li @click="logout">Logout</li>
        </ul>

        <ul
          class="menu-mylists"
          v-if="
            $route.name == 'contests' ||
            $route.name == 'join-contest' ||
            $route.name == 'contest-results'
          "
        >
          <router-link to="/contests" tag="li">Contests</router-link>
          <router-link to="/contests/join" tag="li">Join Contest</router-link>
          <router-link to="/contests/results" tag="li">Results</router-link>
          <li @click="logout">Logout</li>
        </ul>
        <ul
          class="menu-mylists"
          v-if="$route.name == 'rewarder' || $route.name == 'badges'"
        >
          <router-link to="/rewarder" tag="li">My Rewards</router-link>
          <router-link to="/rewarder/badges" tag="li">My Badges</router-link>
        </ul>

        <!-- <input type="text" class="input-search" placeholder="Search ENWOKE" />
      <div id="notifications" class="notifications">
        Notifications
        <div class="notifications-count" v-if="loginStatus">77</div>
      </div> -->
      </div>
    </Slide>

    <div class="login">
      <template v-if="isLoggedIn">
        <div>
          Welcome, {{ loggedInUser }} |
          <span class="logout-link" @click="logout">Logout</span>
        </div>
      </template>
      <template v-else>
        <div class="login-link">
          <router-link to="/signin">Sign In</router-link>
        </div>
      </template>
      <!-- <div id="language" class="language">
				<img :src="language.en" all="Logo EW" />
			</div> -->
      <transition name="fade">
        <div class="login-form" v-if="showLogin">
          <form @submit.prevent="loginFormSubmit" class="form-inline">
            <input
              type="text"
              v-model="loginForm.username"
              placeholder="Username"
              required
              ref="username"
              class="form-control input-flat"
            />
            <input
              type="password"
              v-model="loginForm.password"
              placeholder="Password"
              required
              class="form-control input-flat"
            />
            <input
              type="submit"
              id="tooltip-button-1"
              value="submit"
              class="btn btn-submit"
            />
            <b-tooltip
              :show.sync="tooltip"
              target="tooltip-button-1"
              placement="bottom"
              >{{ msgTooltip }}</b-tooltip
            >
          </form>
          <div class="forgot-password" @click="onClickForgotPassword">
            Forgot Password
          </div>
        </div>
      </transition>
    </div>

    <v-dialog v-model="showForgotPasswordDialog" max-width="500">
      <v-card>
        <v-card-title>Reset password</v-card-title>
        <v-card-text>
          <p>
            To reset your password, please provide us with your email address.
          </p>
          <form
            @submit.prevent="onForgotPasswordFormSubmit"
            :style="{
              display: 'flex',
              jutifyContent: 'space-between',
              width: '100%',
              marginBottom: '10px',
            }"
          >
            <input
              type="email"
              v-model="forgotPasswordEmail"
              @change="onForgotPasswordInputChange"
              placeholder="Email"
              :style="{ width: '70%', padding: '5px 15px' }"
            />
            <input
              type="submit"
              :value="isSubmitForgotPassword ? 'Submitted' : 'Reset Password'"
              class="btn btn-primary"
              :disabled="isSubmitForgotPassword"
              :style="{ textTransform: 'uppercase', marginLeft: '10px' }"
            />
          </form>
          <div class="text-success" v-if="forgotPasswordSendSuccess">
            An email with a reset link has been sent to you.
          </div>
          <div class="text-danger" v-if="forgotPasswordNoEmail">
            There is no account registered under this email.
          </div>
          <div class="text-danger" v-if="forgotPasswordInvalidEmail">
            Please enter a valid email address.
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import logo from "@/assets/images/EW-logo_green-black_horizontal.png";
import En from "@/assets/images/en.png";
import { Slide } from "vue-burger-menu";
import { logout, isEmailValid } from "@/services/UserService";
import { setTimeout } from "timers";

export default {
  name: "nav-header",
  components: {
    Slide,
  },
  computed: {
    isLoggedIn() {
      return !!this.$store.state.auth;
    },
    loggedInUser() {
      const auth = this.$store.state.auth;
      if (auth && auth.user) {
        const user = auth.user;
        if (user.firstName) {
          return user.firstName;
        } else {
          return user.username;
        }
      }
    },
  },
  data() {
    return {
      logo: logo,
      language: {
        en: En,
      },
      loginStatus: true,
      showLogin: false,
      showForgotPasswordDialog: false,
      loginForm: {
        username: "",
        password: "",
      },
      forgotPasswordEmail: "",
      forgotPasswordSendSuccess: false,
      forgotPasswordNoEmail: false,
      forgotPasswordInvalidEmail: false,
      isSubmitForgotPassword: false,
      tooltip: false,
      msgTooltip: "Click!",
    };
  },
  methods: {
    toggleLoginForm() {
      this.loginForm.username = "";
      this.loginForm.password = "";
      if (this.showLogin) {
        this.showLogin = false;
      } else {
        this.showLogin = true;
      }
    },
    loginFormSubmit() {
      const { username, password } = this.loginForm;
      this.$repo.user.signin(username, password).then((res) => {
        if (res != null) {
          this.$router.push({ name: "dashboard" });
          this.showLogin = false;
          this.loginForm.username = "";
          this.loginForm.password = "";
        } else {
          this.msgTooltip = "login failed wrong username or password";
          this.tooltip = true;

          setTimeout(() => {
            this.tooltip = false;
          }, 3000);

          setTimeout(() => {
            this.msgTooltip = "Click!";
          }, 3500);
        }
      });
    },
    logout() {
      logout();
      window.location.reload();
    },
    onClickForgotPassword() {
      this.showForgotPasswordDialog = true;
    },
    onForgotPasswordInputChange(ev) {
      this.forgotPasswordInvalidEmail = !isEmailValid(this.forgotPasswordEmail);
    },
    onForgotPasswordFormSubmit(ev) {
      ev.preventDefault();
      this.isSubmitForgotPassword = true;
      this.forgotPasswordSendSuccess = false;
      this.forgotPasswordNoEmail = false;
      this.forgotPasswordInvalidEmail = false;

      this.$repo.user
        .isExistsBusinessUserEmail(this.forgotPasswordEmail)
        .then((exists) => {
          if (exists) {
            this.forgotPasswordNoEmail = false;
            this.forgotPasswordSendSuccess = true;

            const resetUrl = `${window.location.protocol}//${window.location.hostname}/account/reset-password`;
            this.$repo.user.requestResetPassword(
              this.forgotPasswordEmail,
              resetUrl
            );

            setTimeout(() => {
              this.isSubmitForgotPassword = false;
              this.forgotPasswordSendSuccess = false;
              this.forgotPasswordEmail = "";
              โ;
            }, 3000);
          } else {
            this.forgotPasswordNoEmail = true;
            this.isSubmitForgotPassword = false;
          }
        });
    },
  },
};
</script>

<style lang="scss">
#nav-header {
  position: fixed;
  top: 0;
  width: 100%;
  height: 61px;
  display: flex;
  border-bottom: 1px #b9b9b9 solid;
  background-color: #fff;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
  z-index: 2;

  .logo {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .form-search {
    position: relative;
    width: 61.09%;
    display: flex;
    padding-left: 50px;

    .input-search {
      width: 70%;
      border: none;
      border-right: 1px #b9b9b9 solid;
      font-size: 18px;
      padding-left: 30px;
      padding-right: 30px;
      visibility: hidden;

      &::placeholder {
        color: #b9b9b9;
      }
    }

    .notifications {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      border-right: 1px #b9b9b9 solid;
    }

    .notifications {
      font-size: 18px;
      color: var(--primary-color);
      width: 20%;
      visibility: hidden;

      .notifications-count {
        display: flex;
        width: 22px;
        height: 22px;
        background-color: #c53f3f;
        color: #fff;
        font-size: 12px;
        font-weight: bold;
        border-radius: 50%;
        align-items: center;
        justify-content: center;
        margin-left: 7px;
      }
    }

    .menu-mylists {
      display: flex;
      width: 100%;
      list-style: none;
      padding: 0;
      margin: 0;

      li {
        cursor: pointer;
        display: flex;
        align-items: center;
        margin: 0;
        font-size: 18px;
        font-family: "Roboto";
        height: 100%;
        border-bottom: 6px solid #fff;

        &.router-link-exact-active {
          border-bottom: 6px solid var(--primary-color);
        }

        & + li {
          margin-left: 50px;
        }
      }
    }

    .menu-promotor {
      display: flex;
      width: 100%;
      list-style: none;
      padding: 0;
      margin: 0;

      li {
        cursor: pointer;
        display: flex;
        align-items: center;
        margin: 0;
        font-size: 18px;
        font-family: "Roboto";
        height: 100%;
        border-bottom: 6px solid #fff;

        &.router-link-exact-active {
          border-bottom: 6px solid var(--promotor-color);
        }

        & + li {
          margin-left: 50px;
        }
      }
    }
  }

  .login {
    width: 30%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 10px;
    position: relative;

    .link-login {
      text-decoration: none;
      padding: 0 20px;
      color: #58595b;
      cursor: pointer;
      user-select: none;
    }

    .icon {
      position: relative;
      width: 50px;
      background-color: #b9b9b9;
      height: 100%;
      cursor: pointer;
      margin-left: 20px;
    }

    .language {
      cursor: pointer;
      position: relative;
      display: flex;
      height: 100%;
      align-items: center;
      justify-content: center;
      border-right: 1px #b9b9b9 solid;
      padding: 10px 5px;
    }

    .login-form {
      position: absolute;
      top: 100%;
      background-color: #fff;
      padding: 30px;
      border: 1px solid #b9b9b9;
      box-shadow: 0 2px 3px rgba(0, 0, 0, 0.16);

      form {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }

      .forgot-password {
        cursor: pointer;
      }

      .input-flat {
        border: 1px #b9b9b9 solid;
        border-radius: 0;
      }

      .btn-submit {
        background-color: var(--primary-color);
        color: #fff;
      }
      // input {
      //   font-size: 0.75rem;
      //   padding: 10px 15px;
      //   border-right: 1px #b9b9b9 solid;
      // }
    }
  }

  .login-link {
    margin-right: 20px;
    a {
      color: black;
      text-decoration: none;
    }
  }

  .logout-link {
    cursor: pointer;
  }

  @media only screen and (min-width: $breakpoint-tablet) {
    .bm-burger-button {
      display: none;
    }

    .logo {
      width: 14.84%;
      border-right: 1px #b9b9b9 solid;
    }

    .login-link {
      margin-right: 50px;
    }
  }

  @media only screen and (max-width: $breakpoint-tablet-ipad) {
    .logo {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .form-search {
      position: relative;
      width: 61.09%;
      display: flex;
      padding-left: 50px;
      .full {
        display: none;
      }

      .input-search {
        width: 70%;
        border: none;
        border-right: 1px #b9b9b9 solid;
        font-size: 18px;
        padding-left: 30px;
        padding-right: 30px;
        visibility: hidden;

        &::placeholder {
          color: #b9b9b9;
        }
      }

      .notifications {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        border-right: 1px #b9b9b9 solid;
      }

      .notifications {
        font-size: 18px;
        color: var(--primary-color);
        width: 20%;
        visibility: hidden;

        .notifications-count {
          display: flex;
          width: 22px;
          height: 22px;
          background-color: #c53f3f;
          color: #fff;
          font-size: 12px;
          font-weight: bold;
          border-radius: 50%;
          align-items: center;
          justify-content: center;
          margin-left: 7px;
        }
      }

      .menu-mylists {
        flex-direction: column;
        width: 100%;
        list-style: none;
        padding: 0;
        margin: 0;

        li {
          cursor: pointer;
          display: flex;
          text-align: left;
          margin: 0;
          font-size: 18px;
          font-family: "Roboto";
          height: 100%;
          border-bottom: 6px solid #fff;

          &.router-link-exact-active {
            border-bottom: 6px solid var(--primary-color);
          }

          & + li {
            margin-left: 0;
          }
        }
      }

      .menu-promotor {
        flex-direction: column;
        width: 100%;
        list-style: none;
        padding: 0;
        margin: 0;

        li {
          cursor: pointer;
          display: flex;
          text-align: left;
          margin: 0;
          font-size: 18px;
          font-family: "Roboto";
          height: 100%;
          border-bottom: 6px solid #fff;

          &.router-link-exact-active {
            border-bottom: 6px solid var(--promotor-color);
          }

          & + li {
            margin-left: 0;
          }
        }
      }
    }

    .login {
      // display: none;
      width: 30%;
      display: none;
      align-items: center;
      justify-content: flex-end;
      padding-right: 30px;
      position: relative;

      .link-login {
        text-decoration: none;
        padding: 0 20px;
        color: #58595b;
        cursor: pointer;
        user-select: none;
      }

      .icon {
        position: relative;
        width: 50px;
        background-color: #b9b9b9;
        height: 100%;
        cursor: pointer;
        margin-left: 20px;
      }

      .language {
        cursor: pointer;
        position: relative;
        display: flex;
        height: 100%;
        align-items: center;
        justify-content: center;
        border-right: 1px #b9b9b9 solid;
        padding: 10px 5px;
      }

      .login-form {
        position: absolute;
        top: 100%;
        background-color: #fff;
        padding: 30px;
        border: 1px solid #b9b9b9;
        box-shadow: 0 2px 3px rgba(0, 0, 0, 0.16);

        form {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .forgot-password {
          cursor: pointer;
        }

        .input-flat {
          border: 1px #b9b9b9 solid;
          border-radius: 0;
        }

        .btn-submit {
          background-color: var(--primary-color);
          color: #fff;
        }
      }
    }
    .full {
      display: none;
    }

    // ********** css for hamburger menu ********************
    .bm-burger-button {
      position: fixed;
      width: 36px;
      height: 30px;
      left: 30px;
      top: 15px;
      cursor: pointer;
    }
    .bm-burger-bars {
      background-color: #373a47;
    }
    .line-style {
      position: absolute;
      height: 20%;
      left: 0;
      right: 0;
    }
    .cross-style {
      position: absolute;
      top: 12px;
      right: 2px;
      cursor: pointer;
    }
    .bm-cross {
      background: #bdc3c7;
    }
    .bm-cross-button {
      height: 24px;
      width: 24px;
    }
    .bm-menu {
      height: 45%; /* 100% Full-height */
      width: 0; /* 0 width - change this with JavaScript */
      position: fixed; /* Stay in place */
      z-index: 1000; /* Stay on top */
      top: 0;
      left: 0;
      background-color: rgb(255, 255, 255); /* Black*/
      overflow-x: hidden; /* Disable horizontal scroll */
      padding-top: 50px; /* Place content 60px from the top */
      transition: 0.5s; /*0.5 second transition effect to slide in the sidenav*/
    }

    .bm-overlay {
      background: rgba(255, 255, 255, 0.3);
    }
    .bm-item-list {
      color: #000000;
      margin-left: 10%;
      font-size: 20px;
    }
    .bm-item-list > * {
      display: flex;
      flex-direction: column;
      padding: 0.7em;
    }
    .bm-item-list > * > span {
      margin-left: 10px;
      font-weight: 700;
      color: white;
    }
    // ********** css for hamburger menu ********************

    .login-link {
      a {
        color: black;
        text-decoration: none;
      }
    }

    .logout-link {
      display: none;
    }
  }
}
</style>
